import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/reports`} component={lazy(() => import(`./reports`))} />
        <Route path={`${APP_PREFIX_PATH}/projects`} component={lazy(() => import(`./projects`))} />
        <Route path={`${APP_PREFIX_PATH}/requests`} component={lazy(() => import(`./requests`))} />
        <Route path={`${APP_PREFIX_PATH}/forms/contact-forms`} component={lazy(() => import(`./contactForms`))} />
        <Route
          path={`${APP_PREFIX_PATH}/forms/product-folder-requests`}
          component={lazy(() => import(`./productFolderRequests`))}
        />
        <Route path={`${APP_PREFIX_PATH}/forms/voice-meetings`} component={lazy(() => import(`./voiceMeetings`))} />
        <Route
          path={`${APP_PREFIX_PATH}/forms/vacancy-applications`}
          component={lazy(() => import(`./vacancyApplications`))}
        />
        <Route path={`${APP_PREFIX_PATH}/admin`} component={lazy(() => import(`./admin`))} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/requests`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
